export default __webpack_public_path__ + "static/media/negotiations-icon.29ff8e86.svg";